var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"floating-fuelman-btn",attrs:{"fab":"","large":"","fixed":"","bottom":"","left":"","color":"red darken-2","loading":_vm.loading,"elevation":"8"},on:{"click":_vm.handleFuelmanClick}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-gas-station")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }